export default __webpack_public_path__ + "static/louise-jones-db2d0b905b6ff4f12753b6106243fef6.png";